export default __webpack_public_path__ + "static/media/richiesta.cfe516ac.svg";